<template>
  <div v-if="content" id="scholar-highlight">
    <section class="scholar-highlight" style="text-align: center">
      <div class="info-container">
        <h1>Scholar Highlight</h1>
        <p>Our current Scholar Highlight is</p>
        <h3>{{ content[0].field_name[0].value }}</h3>
        <img :src="content[0].field_photo[0].url" :alt="content[0].field_photo[0].alt">
        <div v-html="content[0].body[0].value"  style="text-align: left"></div>
      </div>
    </section>

    <app-featured-images></app-featured-images>
  </div>
</template>

<script>
import FeaturedImages from '../../components/blocks/Featured-Images.vue'

export default {
  data() {
    return {
      content: [],
      content: this.getContent()
    }
  },
  components: {
    'app-featured-images': FeaturedImages
  },
  methods: {
    getContent() {
      this.$http.get("https://" + window.location.host + "/bonnyoaks/api/scholar-highlight?_format=json").then(response => {
        this.content = response.body;
      }, response => {
        console.log("Error fetching data from URL!");
      });
    }
  }
}
</script>

